<template>
  <div class="app-container">
    <h1 class="app-tit">{{ t('policy_privacy') }}</h1>
    <div class="head-txt-wrap">
      <strong>시행일 : 2025년 12월 22일</strong>
      <p>
        SconAI(이하 "회사")는 이용자의 개인정보를 소중히 생각하며, 「개인정보 보호법」, 「정보통신 망 이용촉진 및
        정보보호 등에 관한 법률」 등 관련 법령을 준수하고 있습니다. 본 개인정보처리방침은 회사가 제공하는 SconChat
        서비스(이하 "서비스")와 관련하여 회사가 이용자의 개인정보를 어떠한 목적으로, 어떠한 방식으로 수집·이용하고
        있으며, 개인정보보호 를 위해 어떠한 조치를 취하고 있는지 알려드립니다.
      </p>
    </div>
    <div class="marker-txt-wrap">
      <div class="txt-group">
        <h2>제 1조 (총칙)</h2>
        <ul class="marker-dot">
          <li>
            개인정보라 함은 살아있는 개인에 관한 정보로서 성명, 주민등록번호, 영상 등을 통해 개인을 알 아볼 수 있는
            정보를 말합니다.
          </li>
          <li>회사는 개인정보 보호를 위해 본 개인정보처리방침을 제정하고 이를 준수합니다.</li>
          <li>본 방침은 서비스 초기 화면 또는 연결 화면에 공개됩니다.</li>
          <li>개인정보처리방침이 변경되는 경우 웹사이트를 통해 공지합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제2조 (개인정보의수집및이용목적)</h2>
        <ul class="marker-dot">
          <li class="non-marker">회사는 다음의 목적을 위하여 개인정보를 처리하며, 목적 외 용도로 이용되지 않습니다.</li>
          <li>
            <div class="inr">
              <h3>서비스 제공 및 계약 이행</h3>
              <p>회서비스 제공, 결제 및 정산, 본인 확인</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>회원 관리</h3>
              <p>회원 가입 및 관리, 본인 확인, 부정 이용 방지, 민원 처리 및 고지사항 전달</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>서비스 개선</h3>
              <p>서비스 이용 분석, 통계 산출, 맞춤형 서비스 제공 및 신규 서비스 개발</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>마케팅 및 광고</h3>
              <p>이용자의 별도 동의 시 이벤트 안내 및 광고성 정보 제공</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>보안 및 안정성 확보</h3>
              <p>불법·부정 이용 방지 및 서비스 안정성 확보</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 3조 (수집 항목 및 수집 방법)</h2>
        <ul class="marker-dot">
          <li class="non-marker">회사는 서비스 제공을 위해 최소한의 개인정보만을 수집합니다.</li>
          <li>
            <div class="inr">
              <h3>회원 가입 시</h3>
              <p>Google/Meta 계정 정보, 이메일, 고유 식별자, IP 주소</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>구독 서비스 이용 시</h3>
              <p>성명, 연락처, 결제 정보</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>서비스 이용 기록</h3>
              <p>접속 IP, 브라우저 정보, 이용 기록, 쿠키</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>통역·번역 데이터</h3>
              <p>입력·출력된 음성 및 텍스트 데이터 (목적 달성 후 즉시 삭제)</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>고객 문의</h3>
              <p>문의 내용 및 처리 이력</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 4조 (보유 및 이용 기간)</h2>
        <ul class="marker-dot">
          <li class="non-marker">개인정보는 법령 또는 동의받은 기간 동안 보유하며, 목적 달성 시 파기합니다.</li>
          <li>
            <div class="inr">
              <h3>회원 정보</h3>
              <p>회원 탈퇴 또는 목적 달성 시까지</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>결제 및 거래 기록</h3>
              <p>최대 5년 보관</p>
            </div>
          </li>
          <li>
            <div class="inr">
              <h3>접속 기록</h3>
              <p>최대 3개월 보관</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 5조 (제3자 제공)</h2>
        <ul class="marker-dot">
          <li>회사는 원칙적으로 개인정보를 외부에 제공하지 않습니다.</li>
          <li>단, 이용자 동의 또는 법령에 따른 경우는 예외로 합니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 6조 (개인정보 처리 위탁)</h2>
        <ul class="marker-dot">
          <li>결제 처리 : 토스페이먼츠</li>
          <li>클라우드 운영 : AWS, Azure, GCP</li>
          <li>고객 지원 : 문의 응대 및 처리</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 7조 (파기 절차 및 방법)</h2>
        <ul class="marker-dot">
          <li>개인정보는 목적 달성 후 지체 없이 파기됩니다.</li>
          <li>전자 파일 : 복구 불가한 방식으로 삭제</li>
          <li>종이 문서 : 분쇄 또는 소각</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 8조 (이용자의 권리)</h2>
        <ul class="marker-dot">
          <li>이용자는 개인정보 열람, 정정, 삭제, 처리 정지를 요청할 수 있습니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 9조 (쿠키)</h2>
        <ul class="marker-dot">
          <li>회사는 맞춤형 서비스 제공을 위해 쿠키를 사용합니다.</li>
          <li>이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 10조 (개인정보 보호책임자)</h2>
        <ul class="marker-dot">
          <li>개인정보 보호책임자 : Applied AI · 박장원</li>
          <li>연락처 : jwpark@sconai.com</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 11조 (안전성 확보 조치)</h2>
        <ul class="marker-dot">
          <li>관리적 조치 : 내부관리계획 및 교육</li>
          <li>기술적 조치 : 접근 통제, 암호화</li>
          <li>물리적 조치 : 출입 통제</li>
        </ul>
      </div>
      <div class="txt-group">
        <h2>제 12조 (고지)</h2>
        <ul class="marker-dot">
          <li>본 방침은 시행일로부터 적용되며, 변경 시 사전 공지합니다.</li>
        </ul>
      </div>
      <div class="last-txt">시행일: 2025년 12월 22일</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.app-container {
  padding: 0 0 4rem;
}
.head-txt-wrap {
  padding: 1rem 0;
  strong {
    font-size: $font-size-psmall;
    font-weight: 500;
    display: block;
    margin-bottom: $size-xs;
  }
  p {
    font-size: $font-size-psmall;
    color: $color-gray-500;
  }
}
.marker-txt-wrap {
  .marker-dot {
    .non-marker {
      padding-left: 0;
      margin-bottom: $size-s;
      &::before {
        display: none;
      }
    }
    .inr {
      padding-bottom: $size-s;
      h3 {
        font-size: $font-size-psmall;
      }
      p {
        font-size: $font-size-psmall;
      }
    }
  }
  .last-txt {
    padding: 1rem 0;
    font-size: $font-size-psmall;
  }
}
</style>
